<template lang="pug">
    model-form(
        ref="form"
        submit-text="guardar"
        title="crear nomina de pago"
        v-bind="formProps"
        v-model="formData"
        @reset="reset"
        @submit="submit"
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import ProviderPaymentSheetModel from '@/models/Purchase/PchProviderPaymentSheet'
    import CreateProviderPaymentSheetFields from '@/views/Purchase/PchProviderPaymentSheet/partials/CreateProviderPaymentSheetFields'
    //
    export default {
        name: 'provider-payment-sheet',
        components: {
            ModelForm,
        },
        computed: {
            
            //
            ...mapState('AuthModule', [
                'user',
            ]),

            /**
             * 
             */
            fieldsProps() {
                return {
                    selected_payment_date: this.formData.payment_date,
                    payment_date_trigger: this.refresh,
                }
            },

            /**
             *
             */
            formProps() {
                return {
                    fields: CreateProviderPaymentSheetFields(this.fieldsProps),
                }
            },
        },
        data() {
            return {
                formData: null,            
            }
        },
        methods: {
            //
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            //
            ...mapActions('SnackbarModalModule', [
                'resetSnackbarState',
                'setErrorSnackbar',
                'setWarningSnackbar',
                'setSuccessSnackbar',
            ]),

            /**
             *
             */
            error(error) {
                return this.setErrorSnackbar(
                    TranslatorService(ProviderPaymentSheetModel, error.response.data)
                )
            },

            /**
             *
             */
            redirect() {
                this.$router.push({ name: 'provider-payment-sheet-list' })
            },

            /**
             * { function_description }
             */
            refresh() {
                //this.$refs.form.getFieldset().$forceUpdate()
                //console.log(this.$refs.form.getInput('selected').$refs.toolbar.$refs.tablePicker.$refs.table.refresh())
                //this.$refs.form.getInput('selected').reset()
            },

            /**
             * 
             */
            reset() {
                this.formData = new ProviderPaymentSheetModel({
                    g_user_id: this.user.id,
                    pch_detail_provider_payment_sheets: [],
                })
            },

            /**
             * 
             */
            submit() {
                return this.toWait(true).then(this.toCreate).then(this.toWait)
            },

            /**
             *
             */
            success() {
                return this.setSuccessSnackbar('Nómina de pago creada exitosamente.')
            },

            /**
             * 
             */
            toCreate(model) {
                return model
                    .toCreate()
                    .save()
                    .then(this.success)
                    .then(this.redirect)
                    .catch(this.error)
            },

            /**
             * { function_description }
             *
             * @param      {boolean}  [value=false]  The value
             * @return     {<type>}   { description_of_the_return_value }
             */
            toWait(value = false) {
                return this.$refs.form.setWait(value)
            },
        },
        beforeMount() {
            this.setTitleTopBar('Crear nómina de pago')
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can('CREATE_PAYMENT_SHEET')) ctx.$router.push('/')
            })
        },
        mounted() {
            this.reset()
        },
    }
</script>
